import http from "../utils/http";

export class ServiceFactory {
  /**
   * QUOTES
   */
  static async getQuotes(params) {
    return (await http.get("api/service/quotes", { params })).data;
  }

  static async getQuote(id) {
    return (await http.get(`api/service/quotes/${id}`)).data;
  }

  static async saveQuote(reg) {
    if (reg.id)
      return (await http.put(`api/service/quotes/${reg.id}`, reg)).data;
    else return (await http.post("api/service/quotes", reg)).data;
  }

  static async deleteQuote(id) {
    return (await http.delete(`api/service/quotes/${id}`)).data;
  }

  static async getEmployeSChedule(params) {
    return (await http.get("api/service/employee-schedule", { params })).data;
  }

  static async getTreatmentPlanHistory(id) {
    return (await http.get("api/service/treatment-plans/" + id, {
      params: { history: 1 }
    })).data;
  }

  static async getFinancings(params) {
    return (await http.get("api/service/financings", { params })).data;
  }

  static async getFinancing(id) {
    return (await http.get(`api/service/financings/${id}`)).data;
  }

  static async saveFinancing(reg) {
    if (reg.id)
      return (await http.put(`api/service/financings/${reg.id}`, reg)).data;
    else return (await http.post("api/service/financings", reg)).data;
  }

  static async deleteFinancing(id) {
    return (await http.delete(`api/service/financings/${id}`)).data;
  }

  static async scheduleTimes(params) {
    return (await http.get("api/service/schedule-times", { params })).data;
  }

  static async getContactTasks(params) {
    return (await http.get("api/service/contact-tasks", { params })).data;
  }

  static async getContactTask(id) {
    return (await http.get(`api/service/contact-tasks/${id}`)).data;
  }

  static async saveContactTask(reg) {
    if (reg.id)
      return (await http.put(`api/service/contact-tasks/${reg.id}`, reg)).data;
    else return (await http.post("api/service/contact-tasks", reg)).data;
  }

  static async deleteContactTask(id) {
    return (await http.delete(`api/service/contact-tasks/${id}`)).data;
  }
}
export default ServiceFactory;